var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0; 
const DATE_FORMAT = 'mm/dd/yy';

	//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
	let DATE_STYLE = [true];
	let op = 0;
	function calendarRange(date) {
		const DATE_STYLE = [true, '']; // Default to selectable and no style
		const d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn--alt').val());
		const d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut--alt').val());
	
		if (d1 && date.getTime() === d1.getTime()) {
			DATE_STYLE[1] = 'highlight highlight-start'; // Assign a specific class to the start day
		} else if (d2 && date.getTime() === d2.getTime()) {
			DATE_STYLE[1] = 'highlight highlight-end'; // Assign a specific class to the end day
		} else if (d1 && d2 && date > d1 && date < d2) {
			DATE_STYLE[1] = 'highlight'; // Assign a class for in-between days
		}
	
		return DATE_STYLE;
	}
	function calendarRangeHome(date){
		let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn2--alt').val());
		let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut2--alt').val());
		if (d1 && date.getTime() === d1.getTime()) {
			DATE_STYLE[1] = 'highlight highlight-start'; // Assign a specific class to the start day
		} else if (d2 && date.getTime() === d2.getTime()) {
			DATE_STYLE[1] = 'highlight highlight-end'; // Assign a specific class to the end day
		} else if (d1 && d2 && date > d1 && date < d2) {
			DATE_STYLE[1] = 'highlight'; // Assign a class for in-between days
		}else{
			DATE_STYLE[1] = '';
		}
		return DATE_STYLE;
	}
	function calendarSelect(date) {
		const startInput = $('#CheckIn--alt');
		const endInput = $('#CheckOut--alt');
		const rangeInput = $('#CheckInOut');
	
		const start = startInput.val() !== '' ? startInput.val() : $.datepicker.formatDate(DATE_FORMAT, new Date());
		const end = endInput.val() !== '' ? endInput.val() : $.datepicker.formatDate(DATE_FORMAT, new Date());
	
		const startDate = $.datepicker.parseDate(DATE_FORMAT, start);
		const selectedDate = $.datepicker.parseDate(DATE_FORMAT, date);
	
		if (op === 0) {
			// First click: set start date
			op = 1;
			startInput.val(date);
			endInput.val(date);
			rangeInput.val(date + ' - ');
		} else {
			// Second click: set end date
			op = 0;
	
			if (selectedDate <= startDate) {
				// Handle reverse selection
				endInput.val(start);
				startInput.val(date);
			} else {
				endInput.val(date);
			}
	
			rangeInput.val(startInput.val() + ' - ' + endInput.val());
		}
	
		// Force a refresh of the datepicker to apply `beforeShowDay` logic
		$(".calendar-block").datepicker("refresh");
	}
	function calendarSelectHome (date) {
		let start = ($('#CheckIn2--alt').val() !== '') ? $('#CheckIn2--alt').val() : $.datepicker.formatDate(DATE_FORMAT, new Date()),
			end = ($('#CheckOut2--alt').val() !== '') ? $('#CheckOut2--alt').val() : $.datepicker.formatDate(DATE_FORMAT, new Date());

			
		let startDate = $.datepicker.parseDate(DATE_FORMAT, start);
		let selectedDate = $.datepicker.parseDate(DATE_FORMAT, date);

		if ( op === 0 ) {
			op = 1;
			start = date;
			end =  date;
			$(this).val(start + ' - ');
			$(this).data().datepicker.inline = true;
		} else {
			op = 0;
			if(selectedDate <= startDate){
				end = start;
				start = date;
			} else {
				end =  date;
			}
			$(this).val(start + ' - ' + end);
			$(this).data().datepicker.inline = false;
		}
		$('#CheckIn2--alt').val( start );
		$('#CheckOut2--alt').val( end );
	}
	function calendarClose () {
		$(this).data().datepicker.inline = false;
	}

	$(document).ready(function () {	
		const minDate = window.location.href.includes('vessence-barbados') 
			? new Date(2026, 6, 1) // July 2026 (month is 0-indexed)
			: 0;

		$("#CheckInOut2").datepicker({
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 2,
			minDate: minDate,
			beforeShowDay: calendarRangeHome,
			onSelect: calendarSelectHome,
			onClose: calendarClose,
			monthNamesShort: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
		});

		$(".calendar-block").datepicker({
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: minDate,
			rangeSelect: true,
			beforeShowDay: calendarRange,
			onSelect: calendarSelect,
			monthNamesShort: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
		});

		/** Enlarge Click Area for Datepicker Display **/
		const bookingDatesField = document.querySelector('#booking-form2 .field.dates');
		if(bookingDatesField){
			bookingDatesField.addEventListener('click', () => {
				document.querySelector('#CheckInOut2').focus();			
			});                               
		}; 

	});
